import { Dialog, DialogContent, DialogTitle } from 'components/Dialog'
import { IconButton } from 'components/IconButton'
import { X } from 'react-feather'
import { FormText } from './FormText'
import { useHeloc } from './HelocContext'

export const FormDialog = () => {
  const { state, dispatch } = useHeloc()
  return (
    <Dialog
      open={state.modalInfoStatus}
      onClose={() => {
        dispatch({ type: 'SET_MODAL_INFO_STATUS', payload: false })
      }}
      aria-labelledby="alert-dialog-info-title"
      aria-describedby="alert-dialog-info-description"
    >
      <DialogContent>
        <DialogTitle id="alert-dialog-title" className="flex justify-end">
          <IconButton
            onClick={() => {
              dispatch({ type: 'SET_MODAL_INFO_STATUS', payload: false })
            }}
          >
            <X className="text-gray-500" />
          </IconButton>
        </DialogTitle>
        <FormText />
      </DialogContent>
    </Dialog>
  )
}
